export const headerData = {
	title: 'NOW YOU CAN FEEL THE HEAT',
	subTitle: 'Smart New Future',
};
